export enum ELeverOrderNameFront {
  Gold = 'gold',
  Silver = 'silver',
}
